/** Keys in their original LaunchDarkly form, so Code References and a plain grep both resolve. */

export const LD_FLAG_USE_TASK_SYSTEM = 'use-task-system-2-17';

export const LD_FLAG_ENABLE_SESSION_REPLAY = 'enable-session-replay';

export const LD_FLAG_ENABLE_DEV_TOOLBAR = 'enable-dev-toolbar';

export const LD_FLAG_DATA_CHANGE_LOG = 'data-change-log';
